<template>
  <nav>
    <ul class="pagination">
      <li class="page-item">
        <button
          type="button"
          class="page-link"
          v-if="page != 1"
          @click="$emit('update:page', 1)"
        >
          Primeira
        </button>
      </li>
      <li class="page-item">
        <button
          type="button"
          class="page-link"
          v-if="page != 1"
          @click="$emit('update:page', page - 1)"
        >
          &lt;
        </button>
      </li>
      <li
        class="page-item"
        v-for="pageNumber in pages.slice(page - 1, page + 3)"
        v-bind:key="pageNumber"
      >
        <button
          type="button"
          v-bind:class="[pageNumber == page ? 'active' : '']"
          class="page-link"
          @click="$emit('update:page', pageNumber)"
        >
          {{ pageNumber }}
        </button>
      </li>
      <li class="page-item">
        <button
          type="button"
          @click="$emit('update:page', page + 1)"
          v-if="page < pages.length"
          class="page-link"
        >
          >
        </button>
      </li>
      <li class="page-item">
        <button
          type="button"
          v-if="page < pages.length"
          @click="$emit('update:page', pages.length)"
          class="page-link"
        >
          Última
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      default: 0,
    },
    pages: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped>
.pagination {
  align-items: center;
  justify-content: center;
  margin: 15px auto;
  background: transparent !important;
}

.pagination .page-item {
  flex: 0 0 auto !important;
}

.pagination button.page-link.active {
  color: #fff;
  background-color: #0fafd7;
}

@media screen and (max-width: 656px) {
}

@media screen and (min-width: 657px) and (max-width: 807px) {
}

@media screen and (min-width: 808px) and (max-width: 1023px) {
}

@media screen and (min-width: 1024px) and (max-width: 1265px) {
}
</style>
